import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { Subject, debounce, timer } from 'rxjs';

export type SearchInputSize = 'md' | 'lg';

@Component({
  selector: 'xemex-search-input',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss',
})
export class SearchInputComponent {
  private static readonly DEBOUNCE_MS = 500;

  placeholder = input('');
  value = input('');
  size = input<SearchInputSize>('md');

  valueChange = output<string>();

  private input$ = new Subject<string>();
  private lastEmitted: string | null = null;

  constructor() {
    this.input$
      .pipe(
        debounce(() => timer(SearchInputComponent.DEBOUNCE_MS)),
        takeUntilDestroyed(),
      )
      .subscribe(q => {
        if (q === this.lastEmitted) return;
        this.lastEmitted = q;
        this.valueChange.emit(q);
      });
  }

  onInput(event: Event): void {
    this.input$.next((event.target as HTMLInputElement).value);
  }
}
